import { Row, Col } from '../../components/custom';

import firstImage from '../../images/solutions/secondaryRes/one.webp';
import secondImage from '../../images/solutions/secondaryRes/two.webp';
import thirdImage from '../../images/solutions/secondaryRes/three.webp';

export default function SecondaryRes()
{
    return (
        <Col id='secondary-research'>
            <span className='mainTitle title'>Secondary Research Intelligence</span>
            <Row className='big'>
                <img src={firstImage} alt='firstImage'/>
                <Col className='content'>
                    <span className='title'>Curated market signals. Actionable context. No noise.</span>
                    <Col className='descsmall'>
                        <span>In an always-on world flooded with information, finding the <strong> right insight at the right time </strong> is a competitive advantage. Whether you're shaping your employee strategy, refining your customer experience, or scanning the market for emerging risks and trends — secondary research can provide essential clarity.</span>
                        <span>Our <strong> Secondary Research Intelligence Suite </strong> helps organizations distill meaningful insights from public sources, third-party content, and digital footprints — and connect them to internal goals. We go beyond search to deliver structured, synthesized, and strategic intelligence.</span>
                    </Col>
                </Col>
            </Row>
            <Row className='big'>
                <Col className='content'>
                    <span className='title'>What We Help You Do</span>
                    <Col className='descsmall'>
                        <span>
                            <strong>Stay Ahead of Workforce & Experience Trends</strong>
                            <br/>
                            We monitor labor market shifts, talent behavior, workplace sentiment, and evolving employee expectations — helping HR and CX leaders understand what's shaping engagement, retention, and employer brand.
                        </span>
                        <span>
                            <strong>Benchmark Perceptions</strong>
                            <br/>
                            Through careful mining of public sentiment — from Glassdoor, Indeed, G2, and more — we uncover how employees, candidates, or customers talk about your brand and your competitors.
                        </span>
                        <span>
                            <strong>Enrich Internal Insights with External Context</strong>
                            <br/>
                            We bring an outside-in lens to your survey or operational data, helping you interpret internal findings in light of market trends, competitive shifts, or changing expectations.
                        </span>
                        <span>
                            <strong>Deliver Curated, Decision-Ready Summaries</strong>
                            <br/>
                            Our outputs go beyond dump-and-download. We synthesize vast information into structured reports, executive briefs, and thematic alerts that you can use to inform action.
                        </span>
                    </Col>
                </Col>
                <img src={secondImage} alt='secondImage'/>
            </Row>
            <Row className='big'>
                <img src={thirdImage} alt='thirdImage'/>
                <Col className='content'>
                    <span className='title'>Our Unique Value</span>
                    <Col className='descsmall'>
                        <span>
                            <strong>People-Powered Research</strong>
                            <br/>
                            No generic scraping. Our analysts validate, triangulate, and synthesize findings with precision and context.
                        </span>
                        <span>
                            <strong>Consulting-Led Framing</strong>
                            <br/>
                            Every research output is guided by a clear business question — not just "what's out there," but "what does it mean for you."
                        </span>
                        <span>
                            <strong>Strategic + Tactical Value</strong>
                            <br/>
                            We cover the full spectrum — from thematic trend tracking to competitive snapshots and topical deep-dives.
                        </span>
                        <span>
                            <strong>Flexible Delivery Models</strong>
                            <br/>
                            From on-demand research to embedded support models, we tailor our approach to your workflow.
                        </span>
                    </Col>
                </Col>
            </Row>
            <Col className='small'>
                <span className='title'>Ready to Power Your Decisions with Market Intelligence?</span>
                <Col className='content descsmall'>
                    <span>When your internal data doesn't tell the whole story, we help you connect the dots using credible, curated external insight — always framed around your priorities.</span>
                    <span><strong>Explore how external signals can sharpen your internal strategies.</strong></span>
                </Col>
            </Col>
        </Col>
    )
}